import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchNegocioData = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/negocio/${id}`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchDepartamentosData = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/departamentos`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
            'Cache-Control': 'no-cache'
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchNegociosData = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/negocios`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchNegociosFiltersData = async (paginaActual, registrosPorPag, departamento, busqueda, ordenarColumna, orden) => {
    try {
        const response = await axios.post(`${API_URL}/api/negocios/filters`, {

            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "departamento": departamento,
            "order": {
                "orderColumn": ordenarColumna || "",
                "order": orden || ""
            }

        }, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});


        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchCrearNegocio = async (formData) => {
    console.log("formData_feeeee", formData);
    try {
        const response = await axios.post(`${API_URL}/api/negocio`, formData, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEditarNegocio = async (empresaData) => {
    try {
        const response = await axios.put(`${API_URL}/api/editarNegocio/${empresaData.get('Id')}`, empresaData, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});


        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEliminarNegocios= async (ids) => {
    try {
        const idsArray = ids.toString().split(',');
        const promises = idsArray.map(id => axios.delete(`${API_URL}/api/negocio/${id}`, {
            headers: { 
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        }));
        const responses = await Promise.all(promises);
        const response = { data: responses.map(res => res.data) };

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

//Empresas anterior
// import axios from 'axios';
// import { handleAuthError } from '../funciones/authHelper';

// const API_URL = process.env.REACT_APP_API_URL;

// export const fetchEmpresaData = async (id) => {
//     try {
//         const response = await axios.get(`${API_URL}/api/empresa/${id}`, {headers: { 
//             'Authorization': `Bearer ${localStorage.getItem("token")}`
//         }});
//         return response.data;
//     } catch (error) {
//         handleAuthError(error);
//     }
// };

// export const fetchDepartamentosData = async () => {
//     try {
//         const response = await axios.get(`${API_URL}/api/departamentos`, {headers: { 
//             'Authorization': `Bearer ${localStorage.getItem("token")}`,
//             'Cache-Control': 'no-cache'
//         }});
//         return response.data;
//     } catch (error) {
//         handleAuthError(error);
//     }
// };

// export const fetchEmpresasData = async () => {
//     try {
//         const response = await axios.get(`${API_URL}/api/empresas`, {headers: { 
//             'Authorization': `Bearer ${localStorage.getItem("token")}`
//         }});
//         return response.data;
//     } catch (error) {
//         handleAuthError(error);
//     }
// };


// export const fetchEmpresasFiltersData = async (paginaActual, registrosPorPag, departamento, busqueda, ordenarColumna, orden) => {
//     try {
//         const response = await axios.post(`${API_URL}/api/empresas/filters`, {

//             "current_page": paginaActual,
//             "items_per_page": registrosPorPag,
//             "filteredWord": busqueda,
//             "departamento": departamento,
//             "order": {
//                 "orderColumn": ordenarColumna || "",
//                 "order": orden || ""
//             }

//         }, {headers: {
//             'Authorization': `Bearer ${localStorage.getItem("token")}`
//         }});


//         return response.data;
//     } catch (error) {
//         handleAuthError(error);
//     }
// };


// export const fetchCrearEmpresa = async (formData) => {
//     console.log("formData_feeeee", formData);
//     try {
//         const response = await axios.post(`${API_URL}/api/empresa`, formData, {headers: { 
//             'Authorization': `Bearer ${localStorage.getItem("token")}`
//         }});
        
//         return response;
//     } catch (error) {
//         handleAuthError(error);
//     }
// };

// export const fetchEditarEmpresa = async (empresaData) => {
//     try {
//         const response = await axios.put(`${API_URL}/api/editarEmpresa/${empresaData.get('Id')}`, empresaData, {headers: { 
//             'Authorization': `Bearer ${localStorage.getItem("token")}`
//         }});


//         return response;
//     } catch (error) {
//         handleAuthError(error);
//     }
// };

// export const fetchEliminarEmpresas = async (ids) => {
//     try {
//         const idsArray = ids.toString().split(',');
//         const promises = idsArray.map(id => axios.delete(`${API_URL}/api/empresa/${id}`, {
//             headers: { 
//                 'Authorization': `Bearer ${localStorage.getItem("token")}`
//             }
//         }));
//         const responses = await Promise.all(promises);
//         const response = { data: responses.map(res => res.data) };

//         return response.data;
//     } catch (error) {
//         handleAuthError(error);
//     }
// };